/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetEvBatteryManufacturerResponse } from '../models/ApiResponseGetEvBatteryManufacturerResponse';
import type { ApiResponseGetEvBatteryStatusResponse } from '../models/ApiResponseGetEvBatteryStatusResponse';
import type { ApiResponseGetEvChargeHistoryResponse } from '../models/ApiResponseGetEvChargeHistoryResponse';
import type { ApiResponseGetEvChargeSummaryResponse } from '../models/ApiResponseGetEvChargeSummaryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EvBatteryControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 배터리 상태 조회
   * 배터리 관리 점수 조회
   * @returns ApiResponseGetEvBatteryStatusResponse OK
   * @throws ApiError
   */
  public getEvBatteryStatus({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryStatusResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/status/',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 배터리 상태 조회
   * 배터리 관리 점수 조회
   * @returns ApiResponseGetEvBatteryStatusResponse OK
   * @throws ApiError
   */
  public getEvBatteryStatus1({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryStatusResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/status',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 배터리 제조사 조회
   * 배터리 제조사 조회
   * @returns ApiResponseGetEvBatteryManufacturerResponse OK
   * @throws ApiError
   */
  public getEvBatteryManufacturer({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryManufacturerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/manufacturer/',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 배터리 제조사 조회
   * 배터리 제조사 조회
   * @returns ApiResponseGetEvBatteryManufacturerResponse OK
   * @throws ApiError
   */
  public getEvBatteryManufacturer1({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryManufacturerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/manufacturer',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 충전 습관 통계 조회
   * 충전 습관 통계 조회
   * @returns ApiResponseGetEvChargeSummaryResponse OK
   * @throws ApiError
   */
  public getEvChargeSummary({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvChargeSummaryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/charge/summary',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 충전 이력 조회
   * 충전 이력 조회
   * @returns ApiResponseGetEvChargeHistoryResponse OK
   * @throws ApiError
   */
  public getEvChargeHistory({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvChargeHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/charge/history/',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 충전 이력 조회
   * 충전 이력 조회
   * @returns ApiResponseGetEvChargeHistoryResponse OK
   * @throws ApiError
   */
  public getEvChargeHistory1({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvChargeHistoryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/charge/history',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
}
